import React from 'react';
import ServiceDetailTemplate from '../Elements/ServiceDetailTemplate';

const bnrimg = require('../../images/pic1.jpg');
const productImg = require('../../images/Plan_de_obra.png');

const ServiceDetailObra = () => (
    <ServiceDetailTemplate
        moduleKey="obra"
        bnrimg={bnrimg}
        productImg={productImg}
    />
);

export default ServiceDetailObra;
